import { useParams, useNavigate } from "react-router-dom";
import { useContext } from "react";
import { PageTitle } from "../../components/PageTitle";
import { GenericChat } from "../../components/shared/chat";
import { createAdapter } from "../../components/shared/chat";
import { MainContainer } from "../../components/shared/chat";
import { useSmartSessionLoader } from "../../components/shared/chat/hooks";
import { AuthContext } from "../../context/AuthContext";
import { AiPreview } from "../aiPreview/AiPreview";

export const Interview = () => {
    const { sessionId } = useParams<{ sessionId: string }>();
    const navigate = useNavigate();
    const adapter = createAdapter('interview');

    // Get subscription status
    const { canAccess } = useContext(AuthContext);
    const hasActiveSubscription = canAccess('interview-prep');

    // Smart session loading - resolves to sessionId or loading state
    const { resolvedSessionId, isLoading } = useSmartSessionLoader('job_interview', sessionId || null);

    const handleSessionChange = (newSessionId: string) => {
        if (!newSessionId) {
            console.warn('handleSessionChange called with empty sessionId');
            return;
        }
        navigate(`/interview/${newSessionId}`, { replace: true });
    };

    const handleNewSession = () => {
        navigate('/interview', { replace: true });
    };

    // Job context is now handled through sessions, no localStorage needed
    const initialContext = undefined;

    // Show loading state when resolving which session to use
    if (isLoading) {
        return (
            <div>
                <PageTitle title="Interviewvorbereitung" />
                <MainContainer>
                    <div style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        height: '50vh',
                        flexDirection: 'column',
                        gap: '16px'
                    }}>
                        <div style={{ fontSize: '16px', color: '#666' }}>
                            Lade letzte Interview-Sitzung...
                        </div>
                    </div>
                </MainContainer>
            </div>
        );
    }

    return (
        <div>
            <PageTitle title="Interviewvorbereitung" />
            <div>
                <MainContainer>
                    <div style={{ position: 'relative', height: '100%' }}>
                        {!hasActiveSubscription && (
                            <div style={{
                                position: 'absolute',
                                top: 0,
                                left: 0,
                                right: 0,
                                bottom: 0,
                                zIndex: 99,
                            }}>
                                    <AiPreview />
                            </div>
                        )}
                        <GenericChat
                            adapter={adapter}
                            customComponents={[]}
                            useTextArea={true}
                            hasActiveSubscription={hasActiveSubscription}
                            placeholder="Erzählen Sie mir von Ihren Vorstellungsgesprächen..."
                            loadingText="Interview Coach schreibt..."
                            loginPrompt="Bitte melden Sie sich an, um Ihre Interview-Vorbereitung zu starten."
                            showSidebar={true}
                            onSessionChange={handleSessionChange}
                            initialSessionId={resolvedSessionId}
                            onNewSession={handleNewSession}
                            initialContext={initialContext}
                            conversationType="job_interview"
                        />
                    </div>
                </MainContainer>
            </div>
        </div>
    );
};
